export enum ProcessRespondentSelectionCriterionType {
  None = 0,
  NoneDescription = "None",
  TeamSelection = 1,
  TeamSelectionDescription = "Team",
  GradeBelowRespondentMinAmount = 2,
  GradeBelowRespondentMinAmountDescription = "Junior grade",
  GradeEqualRespondentMinAmount = 3,
  GradeEqualRespondentMinAmountDescription = "Same grade",
  GradeAboveRespondentMinAmount = 4,
  GradeAboveRespondentMinAmountDescription = "Senior grade",
  TeamMinAmount = 5,
  TeamMinAmountDescription = "Subordinates",
  OtherRespondentMinAmount = 6,
  OtherRespondentMinAmountDescription = "Other",
  Combined = 7,
  CombinedDescription = "Combined",
  MarsProject = 8,
  MarsProjectDescription = "Mars Project",
  BUSelection = 9,
  BUSelectionDescription = "BU Selection"
}